export * from './school-auth-data.interface';
